//autocomplete.js@7.2.0
var a,b;a=this,b=function(){"use strict";function i(e,t){for(var n=0;n<t.length;n++){var i=t[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(e,i.key,i)}}function s(e){return e.innerHTML=""}function d(t,e,n,i,o,r){i({event:t,query:e instanceof HTMLInputElement?e.value:e.innerHTML,matches:o.matches,results:o.list.map(function(e){return e.value}),selection:o.list.find(function(e){return t.keyCode===f?e.index===Number(r.getAttribute(a)):"mousedown"===t.type?e.index===Number(t.currentTarget.getAttribute(a)):void 0})}),s(n)}function e(e,t){t=t||{bubbles:!1,cancelable:!1,detail:void 0};var n=document.createEvent("CustomEvent");return n.initCustomEvent(e,t.bubbles,t.cancelable,t.detail),n}var a="data-id",n="autoComplete_list",l="autoComplete_result",t="autoComplete_highlighted",h="autoComplete_selected",f=13,v=38,m=40,Q=function(e){return"string"==typeof e?document.querySelector(e):e()},U=function(e){var t=document.createElement(e.element);return t.setAttribute("id",n),e.container&&e.container(t),e.destination.insertAdjacentElement(e.position,t),t},u=function(e){return"<span class=".concat(t,">").concat(e,"</span>")},c=function(e,o,r){var s=document.createDocumentFragment();o.forEach(function(e,t){var n=document.createElement(r.element),i=o[t].index;n.setAttribute(a,i),n.setAttribute("class",l),r.content?r.content(e,n):n.innerHTML=e.match||e,s.appendChild(n)}),e.appendChild(s)},p=function(t,n,i,o){function r(e){c.classList.remove(h),a=1===e?c.nextSibling:c.previousSibling}function s(e){(c=e).classList.add(h)}var a,l=n.childNodes,u=l.length-1,c=void 0;t.onkeydown=function(e){if(0<l.length)switch(e.keyCode){case v:c?(r(0),s(a||l[u])):s(l[u]);break;case m:c?(r(1),s(a||l[0])):s(l[0]);break;case f:c&&d(e,t,n,i,o,c)}},l.forEach(function(e){e.onmousedown=function(e){return d(e,t,n,i,o)}})},g=s;e.prototype=window.Event.prototype;var y={CustomEventWrapper:"function"==typeof window.CustomEvent&&window.CustomEvent||e,initElementClosestPolyfill:function(){Element.prototype.matches||(Element.prototype.matches=Element.prototype.msMatchesSelector||Element.prototype.webkitMatchesSelector),Element.prototype.closest||(Element.prototype.closest=function(e){var t=this;do{if(t.matches(e))return t;t=t.parentElement||t.parentNode}while(null!==t&&1===t.nodeType);return null})}};return function(){function K(e){!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,K);var t=e.selector,n=void 0===t?"#autoComplete":t,i=e.data,o=i.key,r=i.src,s=i.cache,a=void 0===s||s,l=e.query,u=e.trigger,c=(u=void 0===u?{}:u).event,d=void 0===c?["input"]:c,h=u.condition,f=void 0!==h&&h,v=e.searchEngine,m=void 0===v?"strict":v,p=e.threshold,g=void 0===p?0:p,y=e.debounce,b=void 0===y?0:y,E=e.resultsList,w=(E=void 0===E?{}:E).render,C=void 0!==w&&w,L=E.container,k=void 0!==L&&L,x=E.destination,S=E.position,T=void 0===S?"afterend":S,M=E.element,R=void 0===M?"ul":M,q=E.navigation,H=void 0!==q&&q,A=e.sort,P=void 0!==A&&A,I=e.placeHolder,j=e.maxResults,N=void 0===j?5:j,_=e.resultItem,V=(_=void 0===_?{}:_).content,W=void 0!==V&&V,D=_.element,F=void 0===D?"li":D,O=e.noResults,z=e.highlight,B=void 0!==z&&z,G=e.onSelection,J=C?U({container:k,destination:x||Q(n),position:T,element:R}):null;this.selector=n,this.data={src:function(){return"function"==typeof r?r():r},key:o,cache:a},this.query=l,this.trigger={event:d,condition:f},this.searchEngine="loose"===m?"loose":"function"==typeof m?m:"strict",this.threshold=g,this.debounce=b,this.resultsList={render:C,view:J,navigation:H},this.sort=P,this.placeHolder=I,this.maxResults=N,this.resultItem={content:W,element:F},this.noResults=O,this.highlight=B,this.onSelection=G,this.init()}return function(e,t,n){t&&i(e.prototype,t),n&&i(e,n)}(K,[{key:"search",value:function(e,t){var n=t.toLowerCase();if("loose"===this.searchEngine){e=e.replace(/ /g,"");for(var i=[],o=0,r=0;r<n.length;r++){var s=t[r];o<e.length&&n[r]===e[o]&&(s=this.highlight?u(s):s,o++),i.push(s)}return o===e.length&&i.join("")}if(n.includes(e))return e=new RegExp("".concat(e),"i").exec(t),this.highlight?t.replace(e,u(e)):t}},{key:"listMatchedResults",value:function(n){var u=this;return new Promise(function(e){var l=[];n.filter(function(i,o){function e(e){var t=e?i[e]:i;if(t){var n="function"==typeof u.searchEngine?u.searchEngine(u.queryValue,t):u.search(u.queryValue,t);n&&e?l.push({key:e,index:o,match:n,value:i}):n&&!e&&l.push({index:o,match:n,value:i})}}if(u.data.key){var t=!0,n=!1,r=void 0;try{for(var s,a=u.data.key[Symbol.iterator]();!(t=(s=a.next()).done);t=!0){e(s.value)}}catch(e){n=!0,r=e}finally{try{t||null==a.return||a.return()}finally{if(n)throw r}}}else e()});var t=u.sort?l.sort(u.sort).slice(0,u.maxResults):l.slice(0,u.maxResults);return e({matches:l.length,list:t})})}},{key:"ignite",value:function(){var a=this,l=Q(this.selector);this.placeHolder&&l.setAttribute("placeholder",this.placeHolder);function t(t){Promise.resolve(a.data.cache?a.dataStream:a.data.src()).then(function(e){a.dataStream=e,function(t){function n(e,t){l.dispatchEvent(new y.CustomEventWrapper("autoComplete",{bubbles:!0,detail:{event:e,input:i,query:o,matches:t?t.matches:null,results:t?t.list:null},cancelable:!0}))}var i=l instanceof HTMLInputElement||l instanceof HTMLTextAreaElement?l.value.toLowerCase():l.innerHTML.toLowerCase(),o=a.queryValue=a.query&&a.query.manipulate?a.query.manipulate(i):i,e=a.resultsList.render,r=a.trigger.condition?a.trigger.condition(o):o.length>a.threshold&&o.replace(/ /g,"").length;if(e){var s=a.resultsList.view;g(s);r?a.listMatchedResults(a.dataStream,t).then(function(e){n(t,e),a.resultsList.render&&(0===e.list.length&&a.noResults?a.noResults():(c(s,e.list,a.resultItem),a.onSelection&&(a.resultsList.navigation?a.resultsList.navigation(t,l,s,a.onSelection,e):p(l,s,a.onSelection,e))))}):n(t)}else!e&&r&&a.listMatchedResults(a.dataStream,t).then(function(e){n(t,e)})}(t)})}this.trigger.event.forEach(function(e){l.addEventListener(e,function(n,i){var o;return function(){var e=this,t=arguments;clearTimeout(o),o=setTimeout(function(){return n.apply(e,t)},i)}}(function(e){return t(e)},a.debounce))})}},{key:"init",value:function(){var t=this;this.data.cache?Promise.resolve(this.data.src()).then(function(e){t.dataStream=e,t.ignite()}):this.ignite(),y.initElementClosestPolyfill()}}]),K}()},"object"==typeof exports&&"undefined"!=typeof module?module.exports=b():"function"==typeof define&&define.amd?define(b):a.autoComplete=b();
/**
 * vanilla-ahm: ajax html modification library
 */
AHM = {
    ahm: function(url, options) {
        var options = options || {};

        if ("undefined" == typeof options.dataType) {
            options.dataType = "json";
        }

        var request = new XMLHttpRequest();
        request.open('GET', url, true);
        request.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        request.responseType = options.dataType;
        request.onreadystatechange = function() {
            if (this.readyState === request.DONE && this.status === 200) {
                AHM.ahm_exec(request.response);
            } else {
                if (options.error && "function" == typeof options.error) {
                    options.error(this);
                }
            }
        };
        request.send();
        return false;
    },

    /**
     * ahm form helper extension
     * call this for all form submissions
     * @return false
     */
    // Send form, disables control on submission, doe NOT resets controls on complete
    ahm_form_modal: function(form, options) {
        var options = options || {};
        if ("undefined" == typeof options.complete) {
            options.complete = function(jqXHR, textStatus) {};
        }
        return AHM.ahm_form(form, options);
    },
    // Send form, disables control on submission, resets controls on complete
    ahm_form: function(form, options) {
        //event.preventDefault();
        // get form

        if ("FORM" != form.nodeName)
            form = form.closest('form');

        // get submit
        var submit = form.querySelector(".form-submitter") || form.querySelector("[type='submit']");

        if (submit) {
            submit.setAttribute('disabled', 'disabled');
        }

        /**
         * because FormData cannot work with jQuery object
         */
        var formData = new FormData(form);
        // formData.forEach(function(element) {
        //     console.log(element);
        // });
        var request = new XMLHttpRequest();
        var url = form.getAttribute('action');

        /**
         * because if GET method, request loses get params
         * doesn't add them automatically
         */
        if (form.getAttribute('method') == 'get') {
            url = url + '?' + AHM.serialize_form_data(form);
        }
        request.open(form.getAttribute('method'), url, true);
        request.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        request.onreadystatechange = function() {
            if (this.readyState === request.DONE && this.status === 200) {
                // Request finished. Do processing here.
                setTimeout(
                    function() {
                        submit.removeAttribute('disabled');
                    }, 500
                );
                AHM.ahm_exec(request.response);
            } else if (this.readyState === request.DONE && this.status === 500) {
            }
        };
        request.send(formData);
        return false;
    },

    /**
     * @TODO add discription to the ahm documentation
     * e.g.
     * AHM.ahm_exec({'/alert':'test'}); - built-in function
     * AHM.ahm_exec({"\/Rdf.top_go":"\/my\/agent\/dashboard"}); - json
     * AHM.ahm_exec({/Rdf.top_go: "/my/agent/dashboard"}); - object
     *
     * @param response []string
     */
    ahm_exec: function (response) {
        if (typeof response !== 'object') {
            response = JSON.parse(response);
        }

        for (let [index, params] of Object.entries(response)) {
            // get selector + callback
            var action   = index.split('/');
            var selector = action[0];
            var callback = action[1] ? action[1] : 'html'; // default callback is html

            // execute ahm callback
            AHM.exec(selector, callback, params);
        }
    },

    // execute callbacks: jquery functions/plugins take precedence
    exec: function (selector, callback, params) {
        // check for callback + this in params (object or array)
        if (typeof params == 'object') {
            for (let [index, value] of Object.entries(params)) {
                if (typeof value == 'string' && value.indexOf('function') == 0)
                    params[index] = window['eval']('(' + value + ')');	// yui-compressor hack
                else if (value == 'this')
                    params[index] = options.context;
            }
        }

        // replace this in selectors + params
        if (selector == 'this')
            selector = options.context;
        if (params == 'this')
            params = options.context;

        // get callback namespace
        var namespace;
        if (selector) {
            namespace = document.querySelector(selector);
        } else if (window[callback]) {
            namespace = window;
        } else if (callback.indexOf('.') !== -1) { // only support dot notation
            var method = callback.split('.');
            namespace = window[method[0]];
            callback = method[1];
        } else {
            alert('ahm: undefined callback=' + callback);
            return;
        }

        // exec callback
        if (typeof namespace[callback] == 'function') {
            if (Array.isArray(params)) namespace[callback]['apply'](namespace, params);
            else if (params) namespace[callback](params);
            else namespace[callback]();
        } else {
            namespace.innerHTML = params;
        }
    },

    /**
     * ahm load extension
     * dynamically load javascript only if not previously loaded
     * @return null
     */
    ahm_loaded: [],
    ahm_load: function(url, onload) {
        if (AHM.ahm_loaded.indexOf(url) == -1) {
            AHM.ahm_loaded.push(url);

            var s = document.createElement('script');
            s.src = url;
            if ("function" === typeof(onload)) {
                s.onload = onload;
            }
            document.getElementsByTagName('head')[0].appendChild(s);
        }
    },

    serialize_form_data: function (form) {
        var serialized = [];

        // Loop through each field in the form
        for (var i = 0; i < form.elements.length; i++) {

            var field = form.elements[i];

            // Don't serialize fields without a name, submits, buttons, file and reset inputs, and disabled fields
            if (!field.name || field.disabled || field.type === 'file' || field.type === 'reset' || field.type === 'submit' || field.type === 'button') continue;

            // If a multi-select, get all selections
            if (field.type === 'select-multiple') {
                for (var n = 0; n < field.options.length; n++) {
                    if (!field.options[n].selected) continue;
                    serialized.push(encodeURIComponent(field.name) + "=" + encodeURIComponent(field.options[n].value));
                }
            }

            // Convert field data to a query string
            else if ((field.type !== 'checkbox' && field.type !== 'radio') || field.checked) {
                serialized.push(encodeURIComponent(field.name) + "=" + encodeURIComponent(field.value));
            }
        }

        return serialized.join('&');
    }
};

// delegate default ahm listeners
document.addEventListener("DOMContentLoaded", function() {

    document.querySelectorAll("a.ahm").forEach(
        function (e) { e.setAttribute("ahm-href", e.getAttribute("href")); e.setAttribute("href", "javascript:void(0)") }
    );

    document.querySelectorAll("span.ahm").forEach(
        function(e) {
            if (e.getAttribute("data-url")) {
                if (e.getAttribute("data-delay"))
                    setTimeout(function() {AHM.ahm(e.getAttribute('data-url'), {context:e});}, e.getAttribute('data-delay'));
                else
                    AHM.ahm(e.getAttribute('data-url'), {context:e});
            }
        }
    );

    document.addEventListener("click", function(e) {
        if (e.target) {
            if (e.target.classList.contains("ahm")) {
                switch (e.target.nodeName) {
                    case "A":
                    case "SPAN":
                        e.stopPropagation();e.preventDefault();
                        var href = e.target.getAttribute("ahm-href"); if (!href) { href = e.target.getAttribute("href") }; return AHM.ahm(href, {context:this});
                        break;
                }
            }
        }
    });
    document.addEventListener("submit", function(e) {
        if (e.target) {
            if ("FORM" == e.target.nodeName) {
                if (e.target.classList.contains("ahm")) {
                    e.stopPropagation();e.preventDefault();
                    AHM.ahm_form(e.target);
                    return false;
                } else if (e.target.classList.contains("ahm_modal")) {
                    e.stopPropagation();e.preventDefault();
                    AHM.ahm_form_modal(e.target);
                    return false;
                }
            }
        }
    });
});
JQFrm = {};

JQFrm.modal_id = 0;
JQFrm.last_modal_id;

JQFrm.dialog = function(d, width, is_modal, onclose_cb) {
    is_modal = is_modal ? 1 : 0;

    JQFrm.modal_id++;
    JQFrm.last_modal_id = 'modal' + JQFrm.modal_id;

    // backdrop
    if (!document.querySelector(".modal-backdrop")) {
        var backdrop = document.createElement('template');
        backdrop.innerHTML = '<div class="modal-backdrop show"></div>';
        backdrop = backdrop.content.firstElementChild;
        document.querySelector("body").appendChild(backdrop);
    }

    // dialog layer
    var dialog = document.createElement('template');
    dialog.innerHTML = '<div class="modal" id="' + JQFrm.last_modal_id + '" tabindex="-1" role="content" aria-labelledby="exampleModalLabel" aria-hidden="true"></div>';
    dialog = dialog.content.firstElementChild;

    // content
    var content = document.createElement('template');
    content.innerHTML = '<div class="modal-dialog"><div class="modal-content">'+d+'</div></div>';
    content = content.content.firstElementChild;

    if (width) {
        content.style.width = width;
    }

    // make content modal or not
    content.onclick = function (e) {e.preventDefault();e.stopPropagation()}
    if (is_modal) {
        dialog.onclick = function (e) {e.preventDefault();e.stopPropagation()}
    } else {
        document.querySelector("body").addEventListener("keyup", function(e) {
            if (JQFrm.modal_id) {
                if (e.which == 27) {
                    e.stopPropagation();e.preventDefault();
                    document.querySelector("#" + JQFrm.last_modal_id).click();
                }
            }
        });
        dialog.onclick = onclose_cb?onclose_cb:JQFrm.hideThisModal;
    }

    dialog.appendChild(content);

    // close callback
    dialog.querySelectorAll("[data-dismiss='modal']").forEach(function(e){
            e.onclick = onclose_cb?onclose_cb:JQFrm.hideThisModal;
        }
    )

    // display
    dialog.style.display = "block";
    document.querySelector("body").appendChild(dialog);

};

JQFrm.message = function(msg, header, width, is_modal, hide_buttons, onclose_cb, modal_opts) {
    modal_opts = "undefined" != typeof modal_opts ? modal_opts : {};
    hide_buttons = hide_buttons ? 1 : 0;

    var html = '\
    <div class="modal-header">\
        ' + (header ? '<h5 class="modal-title">' + header + '</h5>' : '&nbsp;') + '\
        <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>\
    </div>\
    <div class="modal-body">' + msg + '</div>\
    ' + (!hide_buttons ? '<div class="modal-footer">\
        <button type="button" class="btn btn-primary" data-dismiss="modal">Ok</button>\
    </div>' : '') + '';

    JQFrm.dialog(html, width, is_modal, onclose_cb, modal_opts);
};

JQFrm.hideModal = function(id) {
    if (id) {
        if (!isNaN(parseInt(id))) {
            id = 'modal'+id;
        }
    } else {
        id = JQFrm.last_modal_id;
    }

    if(id == JQFrm.last_modal_id) {
        JQFrm.modal_id--;
        JQFrm.last_modal_id = 'modal' + JQFrm.modal_id;
        if (!JQFrm.modal_id) {
            if (tmp = document.querySelector(".modal-backdrop")) {
                tmp.remove();
            }
            JQFrm.last_modal_id = "";
        }
    }

    document.querySelector('#' + id).remove();
};

JQFrm.hideThisModal = function(e) {
    var el = e.target;
    if (el.classList.contains("modal")) {
        var id = el.getAttribute("id");
    } else {
        var id = el.closest(".modal").getAttribute("id");
    }
    JQFrm.hideModal(id);
}

JQFrm.completerFactory = function (params) {
    params = params || {};

    // The autoComplete.js Engine instance creator
    const input = document.querySelector("#" + params.input_id);

    if (input.getAttribute("submitter")) {
        input.addEventListener("keyup", function(e){
            if (e.which == 13) {
                e.stopPropagation();e.preventDefault();
                AHM.ahm_form(document.querySelector("#" + params.form_id));
            };
        })
    }

    autoCompletejs = new autoComplete({
        data: {
            src: async () => {
                // Fetch External Data Source
                const query = input.value;
                const source = await fetch(params.src_uri + "?q=" + query);
                const data = await source.json();
                return data;
            },
            cache: false
        },

        selector: "#" + params.input_id,
        threshold: params.threshold || 0,
        debounce: params.debounce || 300, //0
        searchEngine: "loose",
        searchEngine: function(query, record) {
            var recordLowerCase = record.toLowerCase();
            query = query.replace(/ /g, "");
            var match = [];
            var searchPosition = 0;
            for (var number = 0; number < recordLowerCase.length; number++) {
                var recordChar = record[number];
                if (searchPosition < query.length && recordLowerCase[number] === query[searchPosition]) {
                    recordChar = "<span class='autoComplete_highlighted'>".concat(recordChar, "</span>");
                    searchPosition++;
                }
                match.push(recordChar);
            }
            return match.join("");
        },
        highlight: true,
        maxResults: 10,

        resultsList: {
            render: true,
            container: source => {
                source.setAttribute("id", params.input_id + "_list");
            },
            destination: input,
            position: "afterend",
            element: "ul"
        },
        resultItem: {
            content: (data, source) => {
                source.innerHTML = data.match;
            },
            element: "li"
        },
        onSelection: feedback => {
            const selection = feedback.selection.value;

            input.value = selection;

            AHM.ahm_form(document.querySelector("#" + params.form_id));
        }
    });

    // Toggle event for search input
    // showing & hidding results list onfocus / blur
    ["focus", "blur"].forEach(function(eventType) {
        const resultsList = document.querySelector("#" + params.input_id + "_list");

        input.addEventListener(eventType, function() {
            // Hide results list & show other elemennts
            if (eventType === "blur") {
                resultsList.style.display = "none";
            } else if (eventType === "focus") {
                // Show results list & hide other elemennts
                resultsList.style.display = "block";
            }
        });
    });

    return autoCompletejs;
};


//[["msg1", "field1"],["popup_msg", ""],["msgN", "form1"],...]
JQFrm.showError = function() {
    errors = arguments;
    if (!errors[0] || !errors[0][0]) { // cleanup mode. hide all errors on page.
        document.querySelectorAll(".is-invalid").forEach(function(e){e.classList.remove("is-invalid")});
        document.querySelectorAll(".invalid-feedback").forEach(function(e){e.remove()});
        return;
    }
    console.log(errors);
    //clear all errors in the involved forms
    for (i=0; i<errors.length; i++){
        msg = errors[i][0];
        id = errors[i][1];
        if (id) {
            if (!(form = document.querySelector("form#"+id)) ) {
                if (tmp = document.querySelector('#' + id)) {
                    form = tmp.closest('form');
                };
            }

            if (form) {
                form.querySelectorAll(".is-invalid").forEach(function (e) {
                    e.classList.remove("is-invalid")
                });
            }
        }

        document.querySelectorAll(".invalid-feedback").forEach(function(e){e.remove()});
    }

    //show new errors
    focus_first = 0;
    popup_message = "";
    for (i=0; i<errors.length; i++){
        msg = errors[i][0];
        id = errors[i][1];

        if ("function" === typeof(elIdByName)) {
            payFormId = elIdByName(id); // Used only in form of purchase
            if (payFormId && msg) {
                showFieldError(payFormId, msg);
                return;
            }
        }
        if (!id) {
            if (popup_message) {
                popup_message += "<br>";
            }
            popup_message += msg;
        } else if (form = document.querySelector("form#"+id)) {
            if (msg) {
                form.querySelectorAll('.alert').forEach(function(e){e.remove()});
                var template = document.createElement("template");
                template.innerHTML = '<div class="alert alert-primary" role="alert"> ' + msg + '</div>';
                form.prepend(template.content.firstElementChild);
            }
        } else {
            if (! (field = document.querySelector('#' + id)) ) {
                field = document.querySelector('[name='+id+']');
            }
            if ('hidden' == field.getAttribute('type')) {
                continue;
            }
            if (msg) {
                field.classList.add("is-invalid");
                tmp = field.nextElementSibling;
                if (tmp && tmp.classList && !tmp.classList.contains("invalid-feedback")) {
                    var template = document.createElement("template");
                    template.innerHTML = '<div class="invalid-feedback">' + msg + '</div>';
                    field.parentNode.appendChild(template.content.firstElementChild);
                }

                if (!focus_first) {
                    JQFrm.focus_flash(field);
                }
                focus_first = 1;
            }
        }
    }
    if (popup_message) {
        JQFrm.message(popup_message, '<div class="text-danger">Error</div>');//"Error"
    }
    document.querySelector('.is-invalid').addEventListener("keypress", function(e) {
        e.target.classList.remove('is-invalid');
    });
};


JQFrm.go = function(url) {
    if (url.url) {
        url = url.url;
    }
    if (url == window.location.href) {
        window.location.reload(true);
    } else {
        cur_url = window.location.href.split("#")[0];
        new_url = url.split("#")[0];
        //fixup URI-only form
        if (new_url.substring(0, 4) != "http") {
            new_url = window.location.origin + new_url;
        }

        window.location.assign(url);
        if (cur_url == new_url) {
            //force page reload even if only hash part is different
            window.location.reload(true);
        }
    }
};

JQFrm.focus_flash = function(el) {
    el.classList.add("inputBlink");
    el.focus();
    setTimeout(function() { el.classList.remove("inputBlink"); }, 4000);
};

JQFrm.jsLoad = function(name, onload){
    var s = document.createElement('script');
    s.src = name;
    if ("function" === typeof(onload)) {
        s.onload = onload;
    }
    document.getElementsByTagName('head')[0].appendChild(s);
}

JQFrm.cssLoad = function(name){
    var l = document.createElement('link'); l.rel = 'stylesheet';
    l.href = name;
    document.getElementsByTagName('head')[0].appendChild(l);
}
var turnstile_login_id, turnstile_singup_id, turnstile_customer_data_id;

if(typeof window !== 'undefined') {
    
        window.onloadTurnstileCallback = function() {

            if(typeof cf_site_key !== 'undefined') {
                var str_sitekey = cf_site_key;

                if(document.getElementById('form-control') !== null) {
                    turnstile_customer_data_id = turnstile.render('#form-control', {
                        'sitekey': str_sitekey,
                        'response-field-name': 'cf_captcha_token',
                        'callback': function(token) {
                            if(document.getElementById('spinnerTurnstile') !== null) {
                                document.getElementById('spinnerTurnstile').style.display='none';
                            }
                        },
                        'expired-callback': function() {
                            turnstile.reset();
                        }
                    });
                }

                if(document.getElementById('turnstile_login') !== null) {
                    turnstile_login_id = turnstile.render('#turnstile_login', {
                        'sitekey': str_sitekey,
                        'response-field-name': 'cf_captcha_token',
                        'callback': function(token) {
                            if(document.getElementById('spinnerTurnstile') !== null) {
                                document.getElementById('spinnerTurnstile').style.display='none';
                            }
                        },
                        'expired-callback': function() {
                            turnstile.reset();
                        }
                        
                    });
                }

                if(document.getElementById('turnstile_signup') !== null) {
                    turnstile_singup_id = turnstile.render('#turnstile_signup', {
                        'sitekey': str_sitekey,
                        'response-field-name': 'cf_captcha_token',
                        'callback': function(token) {
                            if(document.getElementById('spinnerTurnstile') !== null) {
                                document.getElementById('spinnerTurnstile').style.display='none';
                            }
                        },
                        'expired-callback': function() {
                            turnstile.reset();
                        }
                    });
                }
                
                if(document.getElementById('customer_data') !== null) {
                    turnstile_customer_data_id = turnstile.render('#customer_data', {
                        'sitekey': str_sitekey,
                        'response-field-name': 'cf_captcha_token',
                        'callback': function(token) {
                            if(document.getElementById('spinnerTurnstile') !== null) {
                                document.getElementById('spinnerTurnstile').style.display='none';
                            }

                            if(document.getElementById('checkout-spinner') !== null) {
                                document.getElementById('checkout-spinner').style.display='none';
                            }

                            if(document.getElementById('checkout-text') !== null) {
                                document.getElementById('checkout-text').style.display='inline';
                            }

                            if(document.getElementById('sq-creditcard') !== null) {
                                document.getElementById('sq-creditcard').disabled=false;
                            }
                        },
                        'expired-callback': function() {
                            turnstile.reset();
                        }
                    });
                }
            }
        }
}